import { axiosFormInstance, axiosInstance, axiosPaymnetInstance } from "./axiosInstances";

let header_token
export const setHeader = async (token) => {
  header_token=token
  
};

const exports = {
    setHeader,
};

export default exports;

export const addData = async (endpoint, requestBody) => {
  try {

   const headers= {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'SessonId': sessionStorage.getItem('session')?.replace('"','').replace('"',''),
        }
    axiosInstance.headers=headers;
    const result = await axiosInstance.post(endpoint, requestBody);
    return result;
  } catch (error) {
    return error;
  }
};

export const addFormData = async (endpoint, requestBody) => {
  try {
    
    const result = await axiosFormInstance.post(endpoint, requestBody);
    return result;
  } catch (error) {
    return error;
  }
};

export const updateData = async (endpoint, requestBody) => {
  try {
    const result = await axiosInstance.put(endpoint, requestBody);
    return result;
  } catch (error) {
    return error;
  }
};
export const updateFormData = async (endpoint, requestBody) => {
  try {
    const result = await axiosFormInstance.patch(endpoint, requestBody);
    return result;
  } catch (error) {
    return error;
  }
};
export const deleteData = async (endpoint) => {
  try {
    const result = await axiosInstance.delete(endpoint);
    return result;
  } catch (error) {
    return error;
  }
};

export const getAllData = async (url) => {
  try {
    
   const SessonId= sessionStorage.getItem('session')?.replace('"','').replace('"','');
    axiosInstance.defaults.headers.common['SessonId'] = SessonId;
    let result = await axiosInstance.get(url);
    return result.data;
  } catch (error) {
    return error.response;
  }
};
export const getAllSportData = async (url) => {
  try {
    axiosInstance.defaults.headers.common = [];
    let result = await axiosInstance.get(url);
    return result.data;
  } catch (error) {
    return error.response;
  }
};

export const getAllFilterData = async (url,data) => {
  try {
    const SessonId= sessionStorage.getItem('session')?.replace('"','').replace('"','');
    axiosInstance.defaults.headers.common['SessonId'] = SessonId;
    let result = await axiosInstance.post(`${url}`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getAllPaymentFilterData = async (url,data) => {
  try {
    let result = await axiosPaymnetInstance.post(`${url}`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getAllReport = async (url, data) => {
  try {
    const SessonId= sessionStorage.getItem('session')?.replace('"','').replace('"','');
    axiosInstance.defaults.headers.common['SessonId'] = SessonId;
    let result = await axiosInstance.post(`${url}`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateUser = async (url, data) => {
  try {
    
   const headers= {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'SessonId': sessionStorage.getItem('session')?.replace('"','').replace('"',''),
      }
  axiosInstance.headers=headers;
    let result = await axiosInstance.put(`${url}`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};


export async function  fetchAllData (url){
  // let tokenStr = await getHeaders(); 
  var myHeaders = new Headers();
  // myHeaders.append("Authorization", `Bearer ${tokenStr}`);

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  // return fetch(BASE_URL+url, requestOptions);
  return fetch(url, requestOptions);
}

